<template>
  <div id="about">
    <h1 class="page-title">
      <span class="highlight">sobre</span>
      a exception jr
    </h1>
    <div id="container-text-about">
      <h2>
        nossa
        <span>história</span>
      </h2>
      <transition name="fade-up" appear>
        <div>
          <p>Nós somos uma empresa júnior do curso de Sistemas de Informação da Universidade Federal do Sul e Sudeste do Pará (UNIFESSPA) e atuamos na área de desenvolvimento de software.</p>
          <p>Uma empresa júnior é uma associação civil sem fins lucrativos, que é formada e gerida pelos alunos de um ou mais cursos superiores e tem como principal objetivo, fomentar o aprendizado prático do universitário em sua área de atuação.</p>
        </div>
      </transition>
    </div>
    <div id="container-text-proposito">
      <h2>
        nosso
        <span>propósito</span>
      </h2>
      <transition name="fade-up" appear>
        <div>
          <h3>Missão</h3>
          <p>Oferecer soluções eficientes para a gestão de informação do micro, pequeno e médio empreendedor</p>
        </div>
      </transition>
      <transition name="fade-up" appear>
        <div>
          <h3>Visão</h3>
          <p>Ser uma referência em soluções em software no norte do país</p>
        </div>
      </transition>
      <transition name="fade-up" appear>
        <div>
          <h3>Valores</h3>
          <ul>
            <li>Qualidade</li>
            <li>Responsabilidade</li>
            <li>Melhoria Contínua</li>
            <li>Simplicidade</li>
            <li>Transparência</li>
            <li>Colaboração</li>
            <li>Liderança</li>
            <li>Paixão</li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang='scss'>
.fade-up-enter,
.fade-up-leave-to {
  opacity: 0;
  transform: translate3d(0, 30px, 0);
}

.fade-up-enter-active,
.fade-up-leave-active {
  transition: all 0.5s;
}

#about {
  width: 100%;
  display: flex;
  flex-direction: column;

  h2 {
    font-size: 2.5rem;
    line-height: 2.5rem;
    margin: 30px 0;
    color: $verde-exception;
    span {
      display: block;
    }
  }
  p {
    font-family: $fonte-secundaria;
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
#container-text-about {
  @include for-tablet-portraid-up {
    width: 40vw;
  }
}
#container-text-proposito {
  @include for-tablet-portraid-up {
    width: 40vw;
  }

  div:nth-child(2).fade-up-enter-active,
  div:nth-child(2).fade-up-leave-active {
    transition-delay: 1s;
  }

  div:nth-child(3).fade-up-enter-active,
  div:nth-child(3).fade-up-leave-active {
    transition-delay: 2s;
  }
  div:nth-child(4).fade-up-enter-active,
  div:nth-child(4).fade-up-leave-active {
    transition-delay: 3s;
  }

  h3 {
    font-size: 1.5rem;
  }
  p {
    margin: 0;
  }
}
ul {
  padding-left: 20px;
  display: grid;

  @include for-tablet-portraid-up {
    grid-template-columns: 1fr 1fr;
    align-items: center;
    grid-gap: 5px;
    grid-template-rows: 1fr 1fr 1fr 1fr;
  }
  justify-content: space-between;
}

li {
  font-size: 1rem;
  font-family: $fonte-secundaria;
  @include for-tablet-landscape-up {
  }
}
</style>